import { configureStore } from '@reduxjs/toolkit';

import createRootReducer from './reducer';

const rootReducer = createRootReducer();

export const configureRootStore = (state = {}) =>
  configureStore({ reducer: rootReducer, preloadedState: state });
